import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { userSignUpWithEmailAndPassword } from "../../store/actions/authActions";
import { Redirect, Link } from "react-router-dom";
import Navbar from '../../components/layout/Navbar';

const Register = (props) => {
  // Hooks
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gymSubscriptionCharge, setGymSubscriptionCharge] = useState(0);
  const [password, setPassword] = useState("");
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [authError, setAuthError] = useState("");

  // Handle Sign up
  const handleSignUp = (e) => {
    e.preventDefault();
    setIsSubmitClicked(true);
    setAuthError(null);

    if (name && email && gymSubscriptionCharge && password) {
      userSignUpWithEmailAndPassword({
        name,
        email,
        gymSubscriptionCharge,
        password,
      });
    } else {
      setAuthError("Some field are empty. Please fill.");
      setIsSubmitClicked(false);
    }
  };

  // Handle Signup input
  const handleInput = (e) => {
    const { name, value } = e.currentTarget;
    switch (name) {
      case "name":
        setName(value);
        break;
      case "email":
        setEmail(value);
        break;
      case "gymSubscriptionCharge":
        setGymSubscriptionCharge(parseInt(value));
        break;
      case "password":
        setPassword(value);
        break;
      default:
        break;
    }
  };

  const { userSignUpWithEmailAndPassword, auth, existingUser } = props;
  useEffect(() => {
    if (auth.authError) {
      setAuthError(auth.authError);
      setIsSubmitClicked(false);
    }
  }, [auth]);

  if (existingUser) return <Redirect to="/dashboard" />;

  return (
    <>
    <Navbar />
    <section className="auth">
      <div className="auth__header">
        <h3 className="auth__header__heading">
          Ready to go{" "}
          <span className="auth__header__heading__span">paperless</span>
        </h3>

        <div className="auth__form form">
          <form className="auth__form__container">
            <input
              type="text"
              name="name"
              className="form__input"
              placeholder="Your Gym Name"
              onChange={handleInput}
              required
            />
            <input
              type="email"
              name="email"
              className="form__input"
              placeholder="Your email"
              onChange={handleInput}
              required
            />
            <input
              type="number"
              name="gymSubscriptionCharge"
              className="form__input "
              placeholder="How much you charge members monthly?"
              onChange={handleInput}
              required
            />
            <input
              type="password"
              name="password"
              className="form__input "
              placeholder="Type a password"
              onChange={handleInput}
              required
            />
            <button
              className="auth__form__submit btn btn-md"
              type="button"
              onClick={handleSignUp}
            >
              {!isSubmitClicked ? "Register" : "Registering"}
            </button>
          </form>

          {authError ? <h3 className="auth__form__error">{authError}</h3> : ""}

          <h3 className="auth__form__login__heading">Already joined?</h3>
          <Link to="/login">
            <button className="btn btn-md auth__form__login__button">
              Log in
            </button>
          </Link>
        </div>
      </div>
    </section>
    </>
  );
};

const mapStateToProps = (state) => {
  const existingUser = localStorage.getItem("adminId");
  return {
    auth: state.auth,
    existingUser,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSignUpWithEmailAndPassword: (payload) => {
      dispatch(userSignUpWithEmailAndPassword(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);
